const base64ToBytes = (base64Value) => {
  const binaryString = window.atob(base64Value)
  const bytes = new Uint8Array(binaryString.length)

  for (let index = 0; index < binaryString.length; index += 1) {
    bytes[index] = binaryString.charCodeAt(index)
  }

  return bytes
}

const getAesKey = async (accessToken) => {
  if (!accessToken) {
    throw new Error("Access token not found.")
  }

  // debugger;
  // console.log(accessToken);
  // console.log(process.env.VUE_APP_ENCRYPTION_KEY);
  const encryptionKey = accessToken
  const encodedKey = new TextEncoder().encode(encryptionKey)

  const keyHash = await window.crypto.subtle.digest(
    "SHA-256",
    encodedKey
  )

  return window.crypto.subtle.importKey(
    "raw",
    keyHash,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  )
}

export const decryptPayload = async (encryptedData, accessToken) => {
  const encryptedBytes = base64ToBytes(encryptedData)
  const iv = encryptedBytes.slice(0, 16)
  const ciphertext = encryptedBytes.slice(16)
  const key = await getAesKey(accessToken)
  const decryptedBuffer = await window.crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv,
    },
    key,
    ciphertext
  )
  const decryptedText = new TextDecoder().decode(decryptedBuffer)

  return JSON.parse(decryptedText)
}

export const decryptResponse = async (response, accessToken) => {
  if (!response || !response.data || !response.data.encrypted_data) {
    return response
  }

  const decryptedData = await decryptPayload(response.data.encrypted_data, accessToken)

  return {
    ...response,
    data: decryptedData,
  }
}
